const Warning = () => (
    <svg
        width='117'
        height='117'
        viewBox='0 0 117 117'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='58.5' cy='58.5' r='58.5' fill='#23B3E5' />
        <rect x='53.5' y='28.5' width='9' height='44' rx='4.5' stroke='white' />
        <rect x='53.5' y='79.5' width='9' height='9' rx='4.5' stroke='white' />
    </svg>
);

export default Warning;
